import { CSSProperties } from 'react'
import { RADOM_COLORS } from '../util/Constants'

export const loadingWrapperStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingTop: 140,
  gap: 20
}

export const containerStyle: CSSProperties = {
  flexDirection: 'column',
  fontSize: 14,
  gap: 30
}

export const headerRowStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
}

export const dropdownContentStyle: CSSProperties = {
  fontSize: 14,
  whiteSpace: 'nowrap'
}

export const payoutHeaderStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  fontSize: '32px'
}

export const payoutLogoStyle: CSSProperties = {
  width: 32,
  height: 'auto',
  maxHeight: 32
}

export const tickerBadgeStyle: CSSProperties = {
  background: RADOM_COLORS.GRAY_MED,
  color: RADOM_COLORS.BLACK,
  borderRadius: 10,
  fontSize: 14,
  padding: '5px 10px',
  fontWeight: 400
}

export const feeRowStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 5
}

export const feeLogoStyle: CSSProperties = {
  height: 18,
  width: 18
}

export const ledgerTitleStyle: CSSProperties = {
  fontSize: 18
}

export const ledgerRowStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  gap: 6
}

export const ledgerMutedTextStyle: CSSProperties = {
  color: RADOM_COLORS.GRAY4
}

export const withdrawalTitleStyle: CSSProperties = {
  fontSize: 14,
  paddingBottom: 10
}

export const payoutAddressCellStyle: CSSProperties = {
  display: 'flex',
  gap: 5,
  alignItems: 'center'
}

export const iconButtonNoPaddingStyle: CSSProperties = {
  padding: 0
}

export const copyIconStyle: CSSProperties = {
  width: 17,
  stroke: RADOM_COLORS.GRAY_DARKER as any
}

export const txLinkStyle: CSSProperties = {
  textDecoration: 'underline'
}

export const linkExternalIconStyle: CSSProperties = {
  width: 13,
  stroke: RADOM_COLORS.BLACK as any
}
